import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from 'next/image'

import { FadeUp } from '@happymoneyinc/move'

import Container from '../Container'
import Headline from '../Headline'
import Button from '../Button'
import Text from '../Text'
import BorderBox from '../BorderBox'

const Beliefs = (props) => {
  const {
    data: {
      beliefs_text: beliefsText,
      beliefs_article_eyebrow: articleEyebrow,
      beliefs_article_headline: articleHeadline,
      beliefs_article_date: articleDate,
      beliefs_button_text: buttonText,
      beliefs_article_href: buttonHref
    }
  } = props

  return (
    <Wrapper maxWidth="1220px">
      <StyledFadeUp>
        <BgIcon>
          <Image src={'/clouds-stars-bg.svg'} width={1100} height={699} alt="clouds stars background" />
        </BgIcon>
        <MobileBgIcon margin="20px auto 60px">
          <Image src={'/clouds-stars-mobile-1.svg'} width={239} height={147} alt="clouds stars mobile background 1" />
        </MobileBgIcon>

        <Box align="flex-start">
          <StyledHeadline >{beliefsText}</StyledHeadline>
        </Box>

        <MobileBgIcon margin="20px auto 60px">
          <Image src={'/clouds-stars-mobile-2.svg'} width={94} height={60} alt="clouds stars mobile background 2" />
        </MobileBgIcon>

        {articleHeadline && <Box align="flex-end">
          <CTAWrapper>
            <TextWrapper>
              <Eyebrow size="eyebrow">{articleEyebrow}</Eyebrow>
              <Title >{articleHeadline}</Title>
              <Date>{articleDate}</Date>
            </TextWrapper>
            <StyledButton buttonContent={buttonText} buttonHref={buttonHref} />
          </CTAWrapper>
        </Box>}

        <MobileBgIcon margin="60px auto 20px">
          <Image src={'/clouds-stars-mobile-3.svg'} width={165} height={147} alt="clouds stars mobile background 3" />
        </MobileBgIcon>
      </StyledFadeUp>
    </Wrapper>
  )
}

const BgIcon = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  display: none;
  padding: 0 20px;
  text-align: center;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    display: block;
  }
`

const MobileBgIcon = styled.div`
  margin: ${ ({ margin }) => margin };

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    display: none;
  }
`

const CTAWrapper = styled(BorderBox)`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  width: 100%;
  padding: 32px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    padding: 48px;
    text-align: left;
  }
`

const TextWrapper = styled.div`
  flex-direction: column;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md1 }) {
    max-width: 340px;
  }
`

const Eyebrow = styled(Text)`
  margin: 0 auto;
  text-transform: uppercase;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    margin: initial;
  }
`

const Title = styled(Headline)`
  margin: 48px 0 44px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    max-width: 310px;
  }
`

const Date = styled.p`
  margin: 0;
`

const StyledButton = styled(Button)`
  align-self: center;
  width: 100%;
  margin-top: 24px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    align-self: flex-start;
    width: auto;
    margin-top: 0;
  }
`

const Box = styled.div`
  z-index: 1;
  display: flex;
  text-align: center;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.md }) {
    align-self: ${ ({ align }) => align };
    width: 50%;
    text-align: left;
  }
`

const StyledHeadline = styled(Headline)`
  margin: 0;
`

const Wrapper = styled(Container)`
  background-color: ${ ({ theme }) => theme.colors.azure[3] };
`

const StyledFadeUp = styled(FadeUp)`
  flex-direction: column;
  display: flex;
`

Beliefs.propTypes = {
  data: PropTypes.objectOf(PropTypes.string).isRequired,
}

export default Beliefs
